import { useDataValue } from 'Simple/Data'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let app_id = useDataValue({
    context: 'app',
    path: 'id',
    viewPath: props.viewPath,
  })
  let key = useDataValue({
    context: 'step',
    viewPath: props.viewPath,
    path: 'key',
  })

  return {
    variables: {
      app_id,
      key,
    },
  }
}
